<template>
  <div v-if="res" class="agreement-component">
    <div class="modal-bg" @click.self="closeHandle">
      <div class="modal-wrap">
        <div class="content-wrap">
          <div class="title">{{ res.title }}</div>
          <div v-if="update_time && effect_time" class="date-row">
            <span class="date-item">最近更新日期：{{ update_time }}</span>
            <span class="date-item">生效日期：{{ effect_time }}</span>
          </div>
          <div
            v-for="(item, index) in res.content"
            :key="index"
            class="agreement-wrap"
            v-html="item"
          ></div>
        </div>
        <div class="close" @click="closeHandle"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    res: {
      type: Object,
      default: null,
    },
  },
  computed: {
    update_time() {
      return (this.res && this.res.update_time) || '';
    },
    effect_time() {
      return (this.res && this.res.effect_time) || '';
    },
  },
  mounted() {
    // single 不关注
    const forbiddenScroll = document.querySelector('.enrolment-page');
    if (!forbiddenScroll) {
      return;
    }
    forbiddenScroll.addEventListener(
      'touchmove',
      this.forbiddenScrollHandle,
      false
    );
  },
  destroyed() {
    const forbiddenScroll = document.querySelector('.enrolment-page');
    if (!forbiddenScroll) {
      return;
    }
    forbiddenScroll.removeEventListener(
      'touchmove',
      this.forbiddenScrollHandle,
      false
    );
  },
  methods: {
    closeHandle() {
      this.$emit('closeHandle');
    },
    // 非滚动区域禁止滚动
    forbiddenScrollHandle(e) {
      const canScroll = document.querySelector('.modal-wrap');

      if (!canScroll) {
        return;
      }
      const target = e.target;
      if (!canScroll.contains(target)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
// $main-color: #3b3561;
// $content-color: rgba(
//   $color: #3b3561,
//   $alpha: 0.7,
// );
$main-color: #3c3c52;
$content-color: #6a6a89;
.agreement-component {
  h2 {
    display: block;
    margin-bottom: 16px;
    color: $main-color;
    font-weight: bold;
    font-size: 30px;
    font-family: PingFangSC;
  }

  .ag-content {
    margin-bottom: 32px;
    padding-bottom: 32px;
    color: $content-color;
    font-size: 26px;
    font-family: PingFangSC;
    line-height: 1.77;
  }

  .content-item {
    margin: 16px 0;

    &-title {
      display: block;
      color: $main-color;
      font-weight: bold;
      font-size: 26px;
      line-height: 1.77;
    }
  }

  .list-wrapper {
    list-style-position: inside;
    list-style-type: disc;
  }

  .order-wrapper {
    margin: 16px 0;
    list-style-position: inside;
    list-style-type: decimal;
  }

  .strong {
    font-weight: bold;
  }

  .date-row {
    // font-size: 20px;
    display: flex;
    justify-content: center;
    // flex-direction: ;
    width: 100%;
    margin-bottom: 47px;
    // align-items: center;
    padding-top: 30px;
  }

  .date-row .date-item {
    display: inline-block;
    color: rgba($color: #201f26, $alpha: 0.5);
    font-size: 20px;
    font-family: PingFangSC;
    white-space: nowrap;
    // color: red;
  }
  .date-item + .date-item {
    margin-left: 20px;
  }
}
.agreement-wrap {
  .h3 {
    color: $main-color;
    font-weight: 500;
    font-size: 30px;
    line-height: 1.73;
  }
  .content {
    color: $content-color;
    font-size: 26px;
    line-height: 1.88;
  }
  .h3 + .content {
    margin-top: 8px;
  }
  .content + .content {
    margin-top: 24px;
  }
  .content + .h3 {
    margin-top: 47px;
  }
  .h3 + .h3 {
    margin-top: 47px;
  }
}
</style>

<style lang="scss" scoped>
$main-color: #3c3c52;
$content-color: #6a6a89;
::-webkit-scrollbar {
  width: 6px;
  background: rgba(118, 176, 243, 0);
  border-radius: 5px;
  transform: translateX(-50%);
}
::-webkit-scrollbar-corner {
  border-radius: 24px;
}
::-webkit-scrollbar-thumb {
  width: 8px;
  min-height: 3px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  transform: translateX(-100%);
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.6);
}
::-webkit-scrollbar-track {
  background-color: rgba(118, 176, 243, 0);
}
.main-center-index::-webkit-scrollbar-track-piece {
  background: rgba(118, 176, 243, 0);
}
::-webkit-scrollbar-track-piece {
  background: rgba(118, 176, 243, 0);
}
.agreement-component {
  .modal-bg {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    background-color: rgba(0, 0, 0, 0.75);

    .modal-wrap {
      position: fixed;
      top: 116px;
      left: 50%;
      z-index: 100;
      box-sizing: border-box;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      width: 630px;
      // padding: 0 6px;
      height: 70vh;
      padding: 0px 10px 40px 46px;
      background-color: #ffffff;
      // background-image: url('./assets/ag-bg.png');
      background-size: 100% 100%;
      border-radius: 24px;
      transform: translateX(-50%);

      &::before {
        position: absolute;
        bottom: 0px;
        left: 50%;
        z-index: 101;
        display: block;
        // width: 630px;
        width: 100%;
        height: 100px;
        background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          #fff 50%,
          #ffffff
        );
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
        transform: translateX(-50%);
        content: '';
      }

      &::after {
        position: absolute;
        top: 0px;
        left: 50%;
        z-index: 101;
        display: block;
        // width: 630px;
        width: 100%;
        height: 80px;
        // background-color: #fff;
        background-image: linear-gradient(
          to top,
          rgba(255, 255, 255, 0),
          #fff 50%,
          #ffffff
        );
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        transform: translateX(-50%);
        content: '';
      }

      .content-wrap {
        width: 100%;
        height: 100%;
        padding-top: 100px;
        // margin-top: 40px;
        padding-right: 33px;
        padding-bottom: 40px;
        overflow-x: hidden;
        overflow-y: scroll;
      }

      .title {
        position: relative;
        margin-bottom: 32px;
        color: $main-color;
        font-weight: bolder;
        font-size: 42px;
        text-align: center;
        &::before {
          position: absolute;
          bottom: -11px;
          left: 50%;
          display: block;
          width: 54px;
          height: 8px;
          background-color: #3b3561;
          border-radius: 4px;
          transform: translateX(-50%);
          opacity: 0.3;
          content: '';
        }
        .agreement-wrap {
          display: flex;
          flex-direction: column;
          margin-bottom: 16px;
          color: #3b3561;
        }
      }
      .content-wrap::-webkit-scrollbar {
        width: 16px;
        height: 16px;
        background-color: #f5f5f5;
      }
    }
    .close {
      position: fixed;
      bottom: -100px;
      left: 50%;
      z-index: 100;
      width: 63px;
      height: 63px;
      background-image: url('./assets/ag-close.png');
      background-size: 100% 100%;
      transform: translateX(-50%);
    }
  }
}
</style>
